import React from 'react';

const variants = {
    default: 'bg-gray-100 text-gray-700',
    success: 'bg-emerald-50 text-emerald-700',
    warning: 'bg-amber-50 text-amber-700',
    danger: 'bg-red-50 text-red-700',
    info: 'bg-blue-50 text-blue-700',
    purple: 'bg-purple-50 text-purple-700',
    outline: 'bg-transparent text-gray-600 ring-1 ring-inset ring-gray-200',
};

export default function Badge({
    children,
    variant = 'default',
    dot = false,
    className = '',
}) {
    return (
        <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${variants[variant] || variants.default} ${className}`}>
            {dot && (
                <span className={`h-1.5 w-1.5 rounded-full ${variant === 'success' ? 'bg-emerald-500' : variant === 'danger' ? 'bg-red-500' : variant === 'warning' ? 'bg-amber-500' : 'bg-gray-400'}`} />
            )}
            {children}
        </span>
    );
}
